//
// GENERATED by KVision
//
package pl.finn.forms.podpp

import io.kvision.remote.HttpMethod
import io.kvision.remote.KVServiceManager
import io.kvision.remote.registerKVisionServiceExceptions

expect class PodppService : IPodppService

object PodppServiceManager : KVServiceManager<PodppService>(PodppService::class) {
    init {
        registerKVisionServiceExceptions()
        bind(IPodppService::nowy, HttpMethod.POST, null)
        bind(IPodppService::edycja, HttpMethod.POST, null)
        bind(IPodppService::sprawdz, HttpMethod.POST, null)
        bind(IPodppService::zapisz, HttpMethod.POST, null)
        bind(IPodppService::podglad, HttpMethod.POST, null)
    }
}
